import { render, staticRenderFns } from "./BuyRecord.vue?vue&type=template&id=1ec05e00&scoped=true&"
import script from "./BuyRecord.vue?vue&type=script&lang=js&"
export * from "./BuyRecord.vue?vue&type=script&lang=js&"
import style0 from "./BuyRecord.vue?vue&type=style&index=0&id=1ec05e00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec05e00",
  null
  
)

export default component.exports